import { render, staticRenderFns } from "./boxEdit.vue?vue&type=template&id=0cd6309f&"
import script from "./boxEdit.vue?vue&type=script&lang=js&"
export * from "./boxEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports